import { Pencil } from "lucide-react";
import { useState } from "react";

import { Button } from "@buildpy/ui/button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@buildpy/ui/sheet";
import { Customer } from "@buildpy/core/modules/customer/types";
import CustomerForm, {
  ConsultTradeOption,
  CustomerCodeOptions,
  CustomerFormSection,
  MemberOption,
} from "@/modules/customer/ui/customer-form";

interface Props {
  customer: Customer;
  members: MemberOption[];
  codes: CustomerCodeOptions;
  /** 상담 체크에 깔 공종. 「빌드파이 표준 + 이 회사」. */
  trades: ConsultTradeOption[];
  sections: CustomerFormSection[];
  title: string;
}

/**
 * 상세 화면의 부분 편집. 카드마다 자기 칸만 여는 시트를 갖는다 —
 * 한 칸 고치자고 전체 폼을 다시 채우게 하지 않는다.
 */
const CustomerEditSheet = ({
  customer,
  members,
  codes,
  trades,
  sections,
  title,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button size="sm" variant="outline" onClick={() => setIsOpen(true)}>
        <Pencil className="size-3.5" />
        편집
      </Button>

      <Sheet open={isOpen} onOpenChange={setIsOpen}>
        <SheetContent
          className="flex w-full flex-col gap-y-4 overflow-y-auto p-0 md:max-w-xl lg:max-w-2xl"
          side="right">
          <SheetHeader className="px-4 py-3" isClose variant="sticky">
            <SheetTitle className="text-left text-base">{title}</SheetTitle>
            <SheetDescription className="sr-only">고칠 칸을 바꾼 뒤 저장합니다</SheetDescription>
          </SheetHeader>

          <div className="px-4 pb-6">
            {/* 시트를 열 때마다 새로 마운트해야 최신 값이 기본값으로 들어간다. */}
            {isOpen && (
              <CustomerForm
                codes={codes}
            trades={trades}
                customer={customer}
                members={members}
                sections={sections}
                onCancel={() => setIsOpen(false)}
                onDone={() => setIsOpen(false)}
              />
            )}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};

export default CustomerEditSheet;
